$.fn.bindViewModel = function (o) {
    /// <summary>Binds a view model and attaches it to the element data (data('viewModel'))</summary>
    /// <param name="o" type="Object">Bind options</param>
    /// <returns type="JQuery">Returns the JQuery element(s)</returns>
    
    var observable;

    this.each(function () {
        
        var t = $(this);
        var a = o.action;
        var preBindAdap = o.preBindVMAdapterJs;

        if (o.viewModel && isFunc(preBindAdap)) {
            preBindAdap(o.viewModel);
        }

        //console.info(t.attr('id'));

        // TODO: refactor this if block out, currently only the auth forms use this, login, change password, forgotten password etc
        if (a) {
            a.bind('SetValues', function () {
                var vals = o.targPnl.data('viewModel');
                a.set({ 'values': vals });
            });
            if (!o.viewModel.submit) {
                var submits = $('[data-bind="click: submit"],[data-bind="click:submit"]', t);
                if (submits.length) {
                    o.viewModel.submit = function () {
                        a.execute();
                    };
                }
            }
        }

        // extract the object to bind
        var bo = isObj(o.viewModel) ? o.viewModel : o; // get the bind object

        // get any existing view model
        var vm = t.data('viewModel');

        // set view model attribute so the view model can be retrieved by traversing the DOM
        t.attr('data-viewModel', true);

        // unbind if already bound
        if (vm) kendo.unbind(t);

        // before bind handling
        t.beforeBindViewModel(bo);

        // create the observable
        observable = kendo.observable(bo);
        
        // bind to the element
        kendo.bind(t, observable);

        // store the view model in data, so it can be accessed later
        t.data('viewModel', observable);

        // refresh the form
        t.refreshForm();
    });

    if (!observable && o.returnObservable && o.viewModel) {
        observable = kendo.observable(o.viewModel);
    }

    return o.returnObservable ? observable : this;
}

$.fn.beforeBindViewModel = function (bo) {
    /// <summary>Before view model bind handle</summary>
    /// <param name="bo" type="Object">The object to be bound</param>
    /// <returns type="$">Returns the JQuery element(s)</returns>

    this.each(function () {

        var t = $(this);
        
        // this is important for bound labels, so we can rebind the value and reformat
        t.clearFormattedInnerValues();

        // ensure there are no null linked objects - these break the UI if left as null
        t.find('[data-bind]').each(function (i, el) {

            var props = $(el).getDataBoundProps();

            for (var p in props) {

                var fieldPath;
                if (isStr(p) && (fieldPath = props[p]).indexOf('.') > -1 && !cafm.util.getReference(fieldPath, bo)) {

                    var pathElements = fieldPath.split('.'), working = [];
                    for (var c = 0; c < pathElements.length - 1; c++) {

                        working.push(pathElements[c]);
                        var current = working.join('.');

                        if (!cafm.util.getReference(current, bo) && current.indexOf(']') == -1) {

                            cafm.util.setProperty(bo, current, {});
                        }
                    }
                    break;
                }
            }
        })
    });

    return this;
}

$.fn.rebindViewModel = function (mergeModel) {
    /// <summary>Rebind an element with it's own view model - useful when new markup has been added within the element and it needs to be bound</summary>
    /// <param name="mergeModel" type="Object">An optional object to merge the contents of into the existing view model</param>
    /// <returns type="$">Returns the JQuery element(s)</returns>

    this.each(function (i, el) {

        el = $(el);

        var viewModel = el.getViewModel().toJSON();

        if (mergeModel) {
            viewModel = $.extend(viewModel, mergeModel);
        }

        el.bindViewModel(viewModel);
    });

    return this;
}

$.fn.mergeViewModel = function (o) {
    /// <summary>Binds a view model and attaches it to the element data (data('viewModel'))</summary>
    /// <param name="o" type="Object">Bind options</param>
    /// <returns type="JQuery">Returns the JQuery element(s)</returns>

    this.each(function () {
        var t = $(this);
        var vm = t.data('viewModel');
        if (vm) {
            vm.set(o);
            kendo.bind(t, vm);
            t.refreshForm();
        }
    });
    return this;
}

$.fn.getViewModel = function () {
    /// <summary>Gets a bound view model from the element data (data('viewModel'))</summary>
    /// <returns type="kendo.Observable">Returns the view model object or null if there isn't one</returns>

    return this.data('viewModel');
}

$.fn.getParentViewModel = function () {
    /// <summary>Gets a bound view model from the element data (data('viewModel'))</summary>
    /// <returns type="Object">Returns the view model object or null if there isn't one</returns>

    return this.parents('[data-viewModel]:first').getViewModel();
}

$.fn.setViewModel = function (o) {
    /// <summary>Sets data on a bound view model from the element data (data('viewModel'))</summary>
    /// <param name="o" type="Object">The view model</param>
    /// <returns type="JQuery">The JQuery element</returns>

    this.each(function () {
        var t = $(this);
        var vm = t.data('viewModel');
        if (vm) {
            vm.set(o);
        }
    });
    return this;
}

$.fn.getDataSource = function () {
    /// <summary>Gets the datasource attached to the element (data('dataSource'))</summary>
    /// <returns type="kendo.DataSource">Returns the datasource</returns>

    var element = this;

    if (this.hasClass('cGrdWrap')) {

        element = this.find('.cGrd');
    }

    if (this.hasClass('cLvWrap')) {

        element = this.find('.cLv');
    }

    return element.data('dataSource');
}
$.fn.refreshDataSource = function () {
    /// <summary>Refreshes the datasource attached to the element (data('dataSource'))</summary>
    /// <returns type="JQuery">The jquery element</returns>

    this.each(function () {
        var ds = $(this).data('dataSource');
        if (isFunc(ds.read)) {
            ds.read();
        }
    });

    return this;
}
$.fn.setDataSource = function (ds) {
    /// <summary>Sets a datasource on the matched element(s) the element data (data('viewModel'))</summary>
    /// <param name="ds" type="kendo.DataSource">The datasource</param>
    /// <returns type="JQuery>The jquery element</returns>

    this.each(function () {
        $(this).data('dataSource', ds);
    });
    return this;
}
$.fn.setCriteria = function (criteria) {
    /// <summary>Sets crtieria on the matched element(s) the element data (data('criteria'))</summary>
    /// <param name="criteria" type="Object">The criteria object</param>
    /// <returns type="Object">The criteria object</returns>

    var element = this;

    if (this.hasClass('cGrdWrap')) {

        element = this.find('.cGrd');
    }

    element.each(function () {

        if (criteria && isFunc(criteria.toJSON)) {

            criteria = criteria.toJSON();
        }
        $(this).data('criteria', criteria);
    });
    return this;
}
$.fn.getCriteria = function () {
    /// <summary>Gets crtieria from the matched element</summary>
    /// <returns type="Object">The criteria object</returns>

    var criteria;

    this.each(function () {

        var el = $(this);

        if (el.hasClass('cGrdWrap')) {

            el = el.find('.cGrd');
        }

        criteria = el.data('criteria');
    });

    return criteria;
}
$.fn.getDataBoundFieldName = function () {
    /// <summary>Gets the bound field name for the element</summary>
    /// <returns type="String">The field name</returns>

    var db = this.data('bind');

    if (db && isStr(db)) {

        var pieces = db.split(':');
        var name = pieces.length ? pieces[1].trim() : '';

        if (name.indexOf(',') > -1) {

            name = name.split(',')[0].trim();
        }

        return name;
    }
    else {

        return null;
    }
}
$.fn.getDataBoundProps = function () {
    /// <summary>Gets the bound field name for the element</summary>
    /// <returns type="Array">The field data bind properties</returns>

    var db = this.data('bind'), props = {};

    if (db && isStr(db)) {

        db.split(',').forEach(function (bs) {

            var pieces = bs.split(':');
            props[pieces[0].trim()] = pieces[1].trim()
        })

        return props;
    }
    else {

        return null;
    }
}
$.fn.getDataBoundValue = function () {
        
    if (this.attr('data-bind')) {

        var viewModel = this.getParentViewModel();

        if (!isNullOrUndefined(viewModel)) {

            var fieldName = this.getDataBoundFieldName();
            return viewModel.get(fieldName);
        }
    }

    return null;
}
$.fn.setDataBoundValue = function (value) {

    if (this.attr('data-bind')) {

        var viewModel = this.getParentViewModel();

        if (!isNullOrUndefined(viewModel)) {

            var fieldName = this.getDataBoundFieldName();
            return viewModel.set(fieldName, value);
        }
    }

    return null;
}
$.fn.showHideDataBoundFields = function (vm) {

    if (isNullOrUndefined(vm)) {

        vm = this.getParentViewModel();
    }

    this.find('.cfField').each(function (i, field) {

        field = $(field);

        var fieldName = field.find('[data-bind]').getDataBoundFieldName();

        if (fieldName) {

            var val = vm.get(fieldName);

            if (val) {

                field.show();
            }
            else {

                field.hide();
            }
        }
    });
}